exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FormNote {\n  font-size: 16px;\n  width: 100%;\n  max-width: 340px;\n  margin: 0 auto 24px auto;\n  text-align: center; }\n", ""]);

// exports
